// src/firebase/dimaniwasConfig.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Dimaniwas Firebase configuration
const dimaniwasConfig = {
  apiKey: "AIzaSyAhLvJE0QL0q_5OHcfBHUl2z1tzS312rs0",
  authDomain: "dimaniwascampsite-3a9ec.firebaseapp.com",
  databaseURL: "https://dimaniwascampsite-3a9ec-default-rtdb.firebaseio.com",
  projectId: "dimaniwascampsite-3a9ec",
  storageBucket: "dimaniwascampsite-3a9ec.firebasestorage.app",
  messagingSenderId: "893757507166",
  appId: "1:893757507166:web:3c8324305adf19ebfd16cf"
};

// Initialize a separate Firebase app for Dimaniwas
const dimaniwasApp = initializeApp(dimaniwasConfig, "dimaniwas");
const dimaniwasRtdb = getDatabase(dimaniwasApp);

console.log("Dimaniwas Realtime DB URL:", dimaniwasRtdb.app.options.databaseURL);

export { dimaniwasRtdb };
